import fetchApi from './fetch';
import { BASE_URL } from './../config';

// گرفتن لیست انواع محصول
export function getProductTypes() {
  return fetchApi('/product/types', 'GET');
}

// گرفتن لیست برندهای یک نوع محصول خاص
export function getBrands(productTypeId) {
  return fetchApi(`/product/brands/${productTypeId}`, 'GET');
}

// گرفتن لیست فایل‌های یک برند خاص
export function getFiles(brandId, search = '') {
  const query = search ? `?search=${encodeURIComponent(search)}` : '';
  return fetchApi(`/product/files/${brandId}${query}`, 'GET');
}

// دانلود فایل - نیاز به توکن دارد و خروجی فایل است نه JSON
export async function downloadFile(fileId, fileName) {
  const token = localStorage.getItem('token');

  if (!token) {
    return { success: false, message: 'برای دانلود فایل باید ابتدا وارد حساب کاربری خود شوید.' };
  }

  try {
    const response = await fetch(`${BASE_URL}/product/download/${fileId}`, {
      method: 'GET',
      headers: { Authorization: `Bearer ${token}` }
    });

    if (!response.ok) {
      const errData = await response.json().catch(() => null);
      return {
        success: false,
        message: errData?.message || 'خطا در دانلود فایل.',
        requiresPurchase: errData?.requiresPurchase || false,
        singleFilePrice: errData?.singleFilePrice
      };
    }

    let finalFileName = fileName || 'download';
    const disposition = response.headers.get('Content-Disposition');
    if (disposition) {
      const match = disposition.match(/filename="?([^"]+)"?/);
      if (match && match[1]) {
        finalFileName = decodeURIComponent(match[1]);
      }
    }

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = finalFileName;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

    return { success: true };
  } catch (error) {
    return { success: false, message: 'خطا در ارتباط با سرور.' };
  }
}

// خرید تک فایل
export async function purchaseSingleFile(fileId) {
  const token = localStorage.getItem('token');

  try {
    const response = await fetch(`${BASE_URL}/payment/request-file`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({ fileId })
    });

    const data = await response.json();

    if (!response.ok) {
      return { success: false, message: data.message };
    }

    return { success: true, paymentUrl: data.paymentUrl };
  } catch (error) {
    return { success: false, message: 'خطا در ارتباط با سرور.' };
  }
}